import { connect } from 'react-redux';
import AdBreakPopUp from '../../../components/sections/pluginSettings/AdRules/AdBreakPopUp';
import { updateAdBreak } from '../../../actions';

const mapStateToProps = (state, props) => {
  return {
    data: state.adRules.data[props.index].data[props.type],
    index: props.index,
    type: props.type,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateState: data => {
      dispatch(updateAdBreak(data));
    },
  };
};

const AdBreakPopUpRedux = connect(mapStateToProps, mapDispatchToProps)(AdBreakPopUp);

export default AdBreakPopUpRedux;
